import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { BulkUploadJobStatus, ExcelSchemaValidationResult } from '#models';

@Injectable({ providedIn: 'root' })
export class BulkUploadService {
    private _http = inject(HttpClient);
    private _base = `${environment.apiBaseUrl}/v1/bulkupload`;

    validateSchema(file: File): Observable<ExcelSchemaValidationResult> {
        const formData = new FormData();
        formData.append('excelFile', file, file.name);
        return this._http.post<ExcelSchemaValidationResult>(`${this._base}/validate-schema`, formData, {
            headers: { 'X-Skip-Error-Toast': 'true' },
        });
    }

    // ── Async job-based endpoints ─────────────────────────────────────────────
    uploadFile(file: File, createdBy: string): Observable<{ jobId: string }> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('createdBy', createdBy);
        return this._http.post<{ jobId: string }>(`${this._base}/job`, formData);
    }

    getJobStatus(jobId: string): Observable<BulkUploadJobStatus> {
        return this._http.get<BulkUploadJobStatus>(`${this._base}/job/${jobId}`);
    }
}
